<section class="dsp-main-container">
  <dsp-qa-banner></dsp-qa-banner>
  <dsp-header></dsp-header>
  <!-- Mobile: navigation outside the row div -->
  <dsp-app-navigation *ngIf="isMobile$ | async" [topNavigation]="navigation$ | async" [bottomNavigation]="botNavigation"
    [forceState]="showNav$ | async" [iconTooltips]="true" [sectionTitle]="(page$ | async)" [verticalNavigation]="false">
  </dsp-app-navigation>
  <div class="row" style="width: 100% !important; max-width: unset !important;">
    <!-- Desktop: navigation inside the row div -->
    <dsp-app-navigation id="growth-of-investment-pendo-row" *ngIf="!(isMobile$ | async)"
      [topNavigation]="navigation$ | async" [bottomNavigation]="botNavigation" [forceState]="showNav$ | async"
      [iconTooltips]="true" [sectionTitle]="(isMobile$ | async) ? (page$ | async) : false"
      [verticalNavigation]="!(isMobile$ | async)">
    </dsp-app-navigation>
    <div #scrollContainer cdkScrollable class="dsp-scroll-div" (scroll)="onScroll()">
      <div #scrollTarget class="dsp-hero" [style.height.px]="heroSize$ | async">
        <div class="row" style="margin-right: auto !important; margin-left: auto !important;">
          <div class="columns">
            <div class="dsp-inner-hero">
              <div *ngIf="!(isMobile$ | async)">
                <h1>{{ page$ | async }}</h1>
              </div>
              <div [ngClass]="{
                  'dsp-mobile-hero-filters': (isMobile$ | async),
                  'dsp-hero-filters': !(isMobile$ | async),
                  'dsp-mobile-single-filter': (isMobile$ | async) && !(admin$ | async)
                }" *ngIf="(showFilter$ | async) && (showSecondaryHeader$ | async)">

                <ng-container *ngIf="admin$ | async">
                  <atlas-field-select [id]="'main-filter-client-select'"
                    [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" [style]="'filled'" [widthValue]="330"
                    [fullWidth]="(isMobile$ | async)" [options]="clientOptions$ | async" [(ngModel)]="clientSelectedId"
                    (ngModelChange)="onClientSelectChange($event)" [haloTooltip]="clientFilterAt?.name"
                    [haloTooltipWithArrow]="true" haloTooltipPosition="top" [clearable]="false">
                  </atlas-field-select>
                </ng-container>

                <atlas-field-select [id]="'main-filter-account-select'"
                  [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" [style]="'filled'" [widthValue]="330"
                  [fullWidth]="(isMobile$ | async)" [options]="accountOptions$ | async" [(ngModel)]="accountSelectedId"
                  (ngModelChange)="onAccountSelectChange($event)" [haloTooltip]="accountFilterAt?.display"
                  [haloTooltipWithArrow]="true" haloTooltipPosition="top" [clearable]="false">
                </atlas-field-select>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row dsp-content-row" style="margin-right: auto !important; margin-left: auto !important;">
        <div class="columns mos-u-spacer--margin-bottom-xxlg">
          <router-outlet></router-outlet>
        </div>
      </div>
      <div *ngIf="showHelpBox" class="help-popup">
        <dsp-resource-center (showHelpBoxEvent)="onshowHelpBoxEvent($event)"></dsp-resource-center>
      </div>
      <div *ngIf="!(isMobile$ | async) && !showHelpBox" class="help-button"
        [ngClass]="!(showScrollToTop$ | async) ? 'dsp-floating-button' : 'dsp-floating-button-resource'">
        <!-- <atlas-icon-button icon="icon-question-24" collection="system" alt="Help" (click)="openHelp()"></atlas-icon-button> -->
        <atlas-icon-button class="mos-c-fab-button--lg mos-c-fab-button " [icon]="'icon-question-24'" [size]="'large'"
          [collection]="'system'" [alt]="'Help'" [size]="'xlarge'" (click)="openHelp()"></atlas-icon-button>

      </div>
      <div *ngIf="showScrollToTop$ | async" class="dsp-floating-button help-button">
        <atlas-icon-button class="mos-c-fab-button--lg mos-c-fab-button" [icon]="'icon-arrow-up-24'" [size]="'large'"
          [collection]="'system'" [alt]="'To Top'" [size]="'xlarge'" (click)="onScrollToTop()"></atlas-icon-button>

      </div>
      <dsp-footer></dsp-footer>
    </div>
  </div>
  <!-- <legacy-app-nav class="dsp-app-nav-grow" [topNavigation]="navigation$ | async" [bottomNavigation]="botNavigation"
    [forceState]="showNav$ | async" [iconTooltips]="true" [sectionTitle]="(isMobile$ | async) ? (page$ | async) : false"
    [verticalNavigation]="!(isMobile$ | async)">

  </legacy-app-nav> -->
</section>